<template>
  <resource-edit-wrapper
    ref="resourceEditWrapper"
    :title="$t('resources.pages.edit_page')"
    :need-modal="showModal"
    :show-bottom-actions="true"
    @saveAction="$refs['pageForm'].submit()">
    <PageForm
      is-edit
      :page="item"
      :need-modal="getNeedModalVal()"
      @changeRedirectRouteName="onChangeRedirectRouteName"
      @changeRedirectRouteParams="onChangeRedirectRouteParams"
      @openModal="onOpenModal"
      @isDirtyForm="isDirtyForm"
      @slugUpdated="slugUpdated"
      @statusChanged="statusChanged"
      @finishedSaving="finishedSaving"
      ref="pageForm"></PageForm>
    <template #actions>
      <v-tooltip top v-if="status === 2">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="revertToDraft"
            :loading="toDraftLoading"
            class="spacing-right--16"
            color="primary"
            outlined
            v-bind="attrs"
            v-on="on">
            {{ $t("resources.pages.revert_to_draft") }}
          </v-btn>
        </template>
        {{ $t("resources.pages.revert_to_draft_tooltip") }}
      </v-tooltip>
      <v-btn
        v-if="status === 1"
        @click="save(false)"
        :loading="saveLoading"
        class="spacing-right--16"
        color="primary"
        outlined>
        {{ $t("generic.buttons.save") }}
      </v-btn>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="previewPage" class="spacing-right--16" color="primary" outlined v-bind="attrs" v-on="on">
            {{ $t("generic.buttons.preview") }}
          </v-btn>
        </template>
        {{ $t("resources.pages.preview_tooltip") }}
      </v-tooltip>
      <v-tooltip top v-if="status === 3">
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="revertToDraft" class="spacing-right--16" color="primary" v-bind="attrs" v-on="on">
            {{ $t("resources.pages.revert_to_draft") }}
          </v-btn>
        </template>
        {{ $t("resources.pages.revert_to_draft_tooltip") }}
      </v-tooltip>
      <v-btn v-if="status === 1 || status === 2" @click="save(true)" :loading="publishAndSaveLoading" color="primary">
        {{ status === 2 ? $t("resources.pages.save_and_publish") : $t("resources.pages.publish") }}
      </v-btn>
    </template>
  </resource-edit-wrapper>
</template>

<script>
  import ResourceEditWrapper from "@/components/resourceWrappers/ResourceEditWrapper";
  import PageForm from "@/components/forms/PageForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";
  import Preview from "@/mixins/previewMethod";

  export default {
    components: {
      ResourceEditWrapper,
      PageForm,
    },
    mixins: [resourceCreateAndEditActions, Preview],
    props: {
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        slug: this.item.slug,
        domain: this.item.domain,
        status: this.item.status,
        publishAndSaveLoading: false,
        saveLoading: false,
        toDraftLoading: false,
      };
    },
    methods: {
      getNeedModalVal() {
        return this.$refs.resourceEditWrapper?.needModal;
      },
      onChangeRedirectRouteName(val) {
        this.$refs.resourceEditWrapper.redirectRouteName = val;
      },
      onChangeRedirectRouteParams(val) {
        this.$refs.resourceEditWrapper.redirectRouteParams = val;
      },
      onOpenModal(val) {
        this.$refs.resourceEditWrapper.openModal = val;
      },
      slugUpdated(slug) {
        this.slug = slug;
      },
      statusChanged(status) {
        this.status = status;
      },
      finishedSaving() {
        this.publishAndSaveLoading = false;
        this.saveLoading = false;
        this.toDraftLoading = false;
      },
      save(publish) {
        this.showModal = false;
        if (publish) {
          this.publishAndSaveLoading = true;
          this.$refs["pageForm"].changedStatus = 2;
          this.$refs["pageForm"].submit(
            this.$t("resources.pages.published_page_message"),
            this.$t("resources.pages.published_page_message_link_text"),
          );
        } else {
          this.saveLoading = true;
          this.$refs["pageForm"].submit(this.$t("resources.pages.saved_paged_message"));
        }
      },
      previewPage() {
        this.preview(this.slug, this.domain?.id);
      },
      revertToDraft() {
        this.toDraftLoading = true;
        this.showModal = false;
        this.$refs["pageForm"].changedStatus = 1;
        this.$refs["pageForm"].submit(this.$t("resources.pages.drafted_page_message"));
      },
    },
  };
</script>
